/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_auth_unexpected_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred. Please try again.`)
};

const es_auth_unexpected_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocurrió un error inesperado. Por favor intenta de nuevo.`)
};

const de_auth_unexpected_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.`)
};

const nl_auth_unexpected_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is een onverwachte fout opgetreden. Probeer het opnieuw.`)
};

const fr_auth_unexpected_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur inattendue s’est produite. Veuillez réessayer.`)
};

const it_auth_unexpected_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore imprevisto. Riprova.`)
};

const pt_br2_auth_unexpected_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro inesperado. Tente novamente.`)
};

const pt_auth_unexpected_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro inesperado. Tente novamente.`)
};

const ja_auth_unexpected_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予期しないエラーが発生しました。もう一度お試しください。`)
};

const zh_auth_unexpected_error = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发生意外错误，请重试。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const auth_unexpected_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_unexpected_error(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("auth_unexpected_error", locale)
	if (locale === "en") return en_auth_unexpected_error(inputs)
	if (locale === "es") return es_auth_unexpected_error(inputs)
	if (locale === "de") return de_auth_unexpected_error(inputs)
	if (locale === "nl") return nl_auth_unexpected_error(inputs)
	if (locale === "fr") return fr_auth_unexpected_error(inputs)
	if (locale === "it") return it_auth_unexpected_error(inputs)
	if (locale === "pt-BR") return pt_br2_auth_unexpected_error(inputs)
	if (locale === "pt") return pt_auth_unexpected_error(inputs)
	if (locale === "ja") return ja_auth_unexpected_error(inputs)
	return zh_auth_unexpected_error(inputs)
};